import { navigate } from 'hookrouter';
import React, { useCallback } from 'react';

import { Container } from '../../components/ui/Container';
import { Logo } from '../../components/ui/Logo';
import { PageLayout } from '../../components/ui/PageLayout';

import { StyledHeading, StyledButton } from './styles';

export function NotFoundPage() {
  const goBack = useCallback(() => navigate('/'), []);
  return (
    <PageLayout
      title='Page not found'
      testId='not-found'
      description='There was an error with the page you are trying to access'
    >
      <Container height='auto'>
        <Logo />
        <StyledHeading variant='heading-medium-3'>
          There was an error with the page you are trying to access
        </StyledHeading>
        <StyledButton
          variant='primary'
          size='large'
          onClick={goBack}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              goBack();
            }
          }}
          testId='go-back'
          type='submit'
          label='Go back'
          shape='square'
          fullWidth
        />
      </Container>
    </PageLayout>
  );
}
